import { InstanceBatchLineMaterial } from "../instancing/lines/lineMaterials";
import { Color, Vector3 } from "flavr-math";
import { Renderable } from "../renderable/Renderable";
const tempVector3_1 = new Vector3();
// const tempVector3_2 = new Vector3();
const tempVector3_3 = new Vector3();
const tmpColor = new Color();
export class LineRenderable extends Renderable {
    constructor(owner) {
        super(owner);
        this.type = LineRenderable.typestatic;
    }
    destroy() {
        this.instance && this.instance.destroy();
        this.instance = undefined;
    }
    setVisible(visible) {
        this.instance && this.instance.setVisible(visible);
    }
    createInstance() {
        const batch = this.owner.renderer.getLineBatch(this.owner.modelUID, InstanceBatchLineMaterial.FUZZY_LINE);
        const instance = batch.createInstance();
        instance.setThickness(0.01);
        instance.setFuzzyness(0);
        instance.setVisible(true);
        return instance;
    }
    updateFacet(facet) {
        if (!this.instance) {
            this.instance = this.createInstance();
        }
        this.instance.setColor(tmpColor.setHex(facet.colorHex));
        this.instance.setThickness(facet.thickness);
        this.instance.setFuzzyness(0);
    }
    updateTransform() {
        if (!this.facet)
            return;
        if (!this.instance)
            return;
        const startPos = tempVector3_1.set(-this.facet.length * 0.5, 0, 0).applyMatrix4(this.owner.matrixWorld);
        const endPos = tempVector3_3.set(this.facet.length * 0.5, 0, 0).applyMatrix4(this.owner.matrixWorld);
        this.instance.setStartPoint(startPos);
        this.instance.setEndPoint(endPos);
    }
}
LineRenderable.typestatic = "Line";
